import { z } from 'zod'
import { isValidPhoneNumber } from 'libphonenumber-js'

const addClientSchema = z.object({
  firstName: z.string().min(1, { message: 'First Name is required.' }),
  lastName: z.string(),
  email: z
    .string()
    .email({ message: 'Please enter a valid email.' })
    .or(z.literal('')),
  phoneNumber: z
    .string()
    .refine((phone) => (phone?.length ? isValidPhoneNumber(phone) : false), {
      message: 'Please enter a valid phone number.',
    })
    .or(z.literal('')),
  address: z.object({
    street1: z.string(),
    street2: z.string(),
    city: z.string(),
    state: z.string(),
    zip: z.string(),
    country: z.string(),
  }),
  tagNames: z.array(z.string()),
  manualOptIn: z.boolean(),
  message: z.string(),
})

export { addClientSchema }
export type AddClientSchema = z.infer<typeof addClientSchema>
